import { useState } from 'react';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

enum MODAL_TYPES {
  CONFIRMATION = 'CONFIRMATION',
  DEPLOY = 'DEPLOY',
}

const useAlgoverseDeployment = () => {
  const [modalType, setModalType] = useState<MODAL_TYPES | null>(null);

  // Step 1: Entry point
  const openDeployFlow = (actionCb?: () => void) => {
    if (ApplicationDomainUtility.isAlgoverse) {
      setModalType(MODAL_TYPES.CONFIRMATION);
    } else {
      proceedToDeploy(actionCb);
    }
  };

  // Step 2: Close any modal
  const closeModal = () => {
    setModalType(null);
  };

  // Step 3: After clicking OK in confirmation
  const proceedToDeploy = (actionCb?: () => void) => {
    if (typeof actionCb === 'function') {
      actionCb();
      setModalType(null);
    } else setModalType(MODAL_TYPES.DEPLOY);
  };

  return {
    modalType,
    isConfirmationOpen: modalType === MODAL_TYPES.CONFIRMATION,
    isDeployOpen: modalType === MODAL_TYPES.DEPLOY,

    openDeployFlow,
    closeModal,
    proceedToDeploy,
  };
};

export default useAlgoverseDeployment;
